const APP_COLORS = {
  $PRIMARY_BACKGROUND: '#27352e',
  $SECONDARY_BACKGROUND: '#FFEEE1',
}

export { APP_COLORS }
